import Input from './input';
import TextArea from './TextArea';
export { InputSiteTypes, BorderTypes } from './input'; // export { TextAreaProps } from './TextArea'

export { TextArea };
export default Input;